import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-coaching-goal-box',
    template: ` <div class="cmps-coaching-goal-box--content">
        <div class="cmps-coaching-goal-box--bg"></div>
        <div class="cmps-coaching-goal-box--item">
            <span>{{ goalLabel }}</span>
            <span>{{ goal }}</span>
        </div>
        <div class="cmps-coaching-goal-box--item">
            <span>{{ pctToGoalLabel }}</span>
            <span>{{ pctToGoal }}</span>
        </div>
        <div class="cmps-coaching-goal-box--item">
            <span>{{ pctToTargetLabel }}</span>
            <span>{{ pctToTarget }}</span>
        </div>
    </div>`,
    host: {
        class: 'cmps-coaching-goal-box',
    },
})
export class CmpsGoalBoxComponent {
    @Input() goalLabel: string;
    @Input() goal: string;
    @Input() pctToGoalLabel: string;
    @Input() pctToGoal: string;
    @Input() pctToTargetLabel: string;
    @Input() pctToTarget: string;
}
